document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.ht-tab-btn');
  const tabPanels = document.querySelectorAll('.ht-tab-panel');

  tabButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const targetId = btn.getAttribute('data-tab');

      // Remove active from all + update ARIA
      tabButtons.forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      tabPanels.forEach(p => p.classList.remove('active'));

      // Add active to clicked + update ARIA
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      const targetPanel = document.getElementById('tab-' + targetId);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
    });

    // Keyboard navigation (left/right arrows)
    btn.addEventListener('keydown', (e) => {
      const tabs = Array.from(tabButtons);
      const currentIndex = tabs.indexOf(btn);
      let newIndex;

      if (e.key === 'ArrowRight') {
        newIndex = (currentIndex + 1) % tabs.length;
      } else if (e.key === 'ArrowLeft') {
        newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      } else {
        return;
      }

      e.preventDefault();
      tabs[newIndex].click();
      tabs[newIndex].focus();
    });
  });

  // Custom header buttons (e.g. "Write a Review") that proxy to an app's own button.
  // Judge.me loads async, so retry a few times until its button exists.
  document.querySelectorAll('[data-ht-trigger]').forEach(proxyBtn => {
    proxyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const selector = proxyBtn.getAttribute('data-ht-trigger');
      let attempts = 0;

      const tryClick = () => {
        const target = document.querySelector(selector);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          target.click();
          return true;
        }
        return false;
      };

      if (tryClick()) return;
      const timer = setInterval(() => {
        attempts++;
        if (tryClick() || attempts > 20) clearInterval(timer);
      }, 150);
    });
  });
});
